import BoltIcon from "./bolt.svg?react";
import BracketsIcon from "./brackets.svg?url";
import HalfCircleIcon from "./half-circle.svg?url";
import CaseSensitiveIcon from "./case-sensitive.svg?url";
import SplitHorizontalIcon from "./split-horizontal.svg?url";

import { HTMLAttributes } from "react";

export { default as ThinkingIcon } from "./thinking.svg?react";
export { default as CircleIcon } from "./circle.svg?react";
export { default as DownloadIcon } from "./download.svg?react";
export { default as ArrowRightIcon } from "./arrow-right.svg?react";
export { default as DatabaseIcon } from "./database.svg?react";
export { default as GitMergeIcon } from "./git-merge.svg?react";
export { default as ArrowLeftIcon } from "./arrow-left.svg?react";

interface Props {
  icon: string;
}
const Icon = ({
  icon,
  className = "",
  ...rest
}: Props & HTMLAttributes<HTMLElement>) => (
  <i className={`${className} codicon codicon-${icon}`} {...rest} />
);

export const RemoveIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="remove" {...props} />
);

export const CodeIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="code" {...props} />
);

export const AddIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="add" {...props} />
);

export const DeleteIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="trash" {...props} />
);

export const GlobeIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="globe" {...props} />
);

export const GithubIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="github-inverted" {...props} />
);

export const FilesIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="files" {...props} />
);

export const CommentAddIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="comment-add" {...props} />;

export const CommentDiscussionIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="comment-discussion" {...props} />;

export const CommentUnresolvedIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="comment-unresolved" {...props} />;

export const CheckNoOutlineIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="check" {...props} />;

export const CheckedIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="pass-filled" {...props} />;

export const PassIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="pass" {...props} />
);

export const RefreshIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="debug-restart" {...props} />;

export const SettingsIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="gear" {...props} />;

export const ChevronUpIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="chevron-up" {...props} />;

export const ChevronDownIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="chevron-down" {...props} />;

export const ChevronRightIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="chevron-right" {...props} />;

export const ChevronLeftIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="chevron-left" {...props} />;

export const MoreIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="more" {...props} />
);

export const InfoCircleIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="info" {...props} />;

export const AskIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="send" {...props} />
);

export const CloseIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="close" {...props} />
);

export const EditIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="pencil" {...props} />
);

export const ShareIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="share" {...props} />
);

export const SearchIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="search" {...props} />
);

export const FileIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="file" {...props} />
);

export const WarningIcon = (
  props: HTMLAttributes<HTMLElement>,
): JSX.Element => <Icon icon="warning" {...props} />;

export const SendIcon = (props: HTMLAttributes<HTMLElement>): JSX.Element => (
  <Icon icon="send" {...props} />
);

export {
  BoltIcon,
  BracketsIcon,
  HalfCircleIcon,
  SplitHorizontalIcon,
  CaseSensitiveIcon,
};
